/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateResourceGrantRequest
} from './model/createResourceGrantRequest.js';

import type {
  ListResourceGrantsParams
} from './model/listResourceGrantsParams.js';

import type {
  ResourceGrantListResponse
} from './model/resourceGrantListResponse.js';

import type {
  ResourceGrantResponse
} from './model/resourceGrantResponse.js';

import type {
  SetResourceGrantExpiryRequest
} from './model/setResourceGrantExpiryRequest.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List a page of the grants the caller can see, newest first. Naming one `resourceType` + `resourceId` lists every grant on it when the caller can read that resource.
 */
export const listResourceGrants = (
    params?: ListResourceGrantsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ResourceGrantListResponse>(
      {url: `/resource-grants`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListResourceGrantsQueryKey = (params?: ListResourceGrantsParams,) => {
    return [
    `/resource-grants`, ...(params ? [params] : [])
    ] as const;
    }


export const getListResourceGrantsQueryOptions = <TData = Awaited<ReturnType<typeof listResourceGrants>>, TError = unknown>(params?: ListResourceGrantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResourceGrants>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListResourceGrantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listResourceGrants>>> = ({ signal }) => listResourceGrants(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listResourceGrants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListResourceGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof listResourceGrants>>>
export type ListResourceGrantsQueryError = unknown


/**
 * @summary List a page of the grants the caller can see, newest first. Naming one `resourceType` + `resourceId` lists every grant on it when the caller can read that resource.
 */

export function useListResourceGrants<TData = Awaited<ReturnType<typeof listResourceGrants>>, TError = unknown>(
 params?: ListResourceGrantsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listResourceGrants>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListResourceGrantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Share a resource: open an active grant to a user, team, or the whole org.
 */
export const createResourceGrant = (
    createResourceGrantRequest: CreateResourceGrantRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ResourceGrantResponse>(
      {url: `/resource-grants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createResourceGrantRequest, signal
    },
      options);
    }




export const getCreateResourceGrantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceGrant>>, TError,{data: CreateResourceGrantRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceGrant>>, TError,{data: CreateResourceGrantRequest}, TContext> => {

const mutationKey = ['createResourceGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceGrant>>, {data: CreateResourceGrantRequest}> = (props) => {
          const {data} = props ?? {};

          return  createResourceGrant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceGrantMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceGrant>>>
    export type CreateResourceGrantMutationBody = CreateResourceGrantRequest
    export type CreateResourceGrantMutationError = unknown

    /**
 * @summary Share a resource: open an active grant to a user, team, or the whole org.
 */
export const useCreateResourceGrant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceGrant>>, TError,{data: CreateResourceGrantRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createResourceGrant>>,
        TError,
        {data: CreateResourceGrantRequest},
        TContext
      > => {
      return useMutation(getCreateResourceGrantMutationOptions(options));
    }
    /**
 * @summary Read one grant by id.
 */
export const getResourceGrant = (
    grantId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ResourceGrantResponse>(
      {url: `/resource-grants/${encodeURIComponent(String(grantId))}`, method: 'GET', signal
    },
      options);
    }




export const getGetResourceGrantQueryKey = (grantId: string,) => {
    return [
    `/resource-grants/${grantId}`
    ] as const;
    }


export const getGetResourceGrantQueryOptions = <TData = Awaited<ReturnType<typeof getResourceGrant>>, TError = unknown>(grantId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourceGrant>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceGrantQueryKey(grantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceGrant>>> = ({ signal }) => getResourceGrant(grantId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: grantId !== null && grantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceGrant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourceGrantQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceGrant>>>
export type GetResourceGrantQueryError = unknown


/**
 * @summary Read one grant by id.
 */

export function useGetResourceGrant<TData = Awaited<ReturnType<typeof getResourceGrant>>, TError = unknown>(
 grantId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourceGrant>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetResourceGrantQueryOptions(grantId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Revoke a grant: end its sharing interval now, keeping the row as audit record.
 */
export const revokeResourceGrant = (
    grantId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ResourceGrantResponse>(
      {url: `/resource-grants/${encodeURIComponent(String(grantId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeResourceGrantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeResourceGrant>>, TError,{grantId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeResourceGrant>>, TError,{grantId: string}, TContext> => {

const mutationKey = ['revokeResourceGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeResourceGrant>>, {grantId: string}> = (props) => {
          const {grantId} = props ?? {};

          return  revokeResourceGrant(grantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeResourceGrantMutationResult = NonNullable<Awaited<ReturnType<typeof revokeResourceGrant>>>

    export type RevokeResourceGrantMutationError = unknown

    /**
 * @summary Revoke a grant: end its sharing interval now, keeping the row as audit record.
 */
export const useRevokeResourceGrant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeResourceGrant>>, TError,{grantId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeResourceGrant>>,
        TError,
        {grantId: string},
        TContext
      > => {
      return useMutation(getRevokeResourceGrantMutationOptions(options));
    }
    /**
 * @summary Move an active grant expiry: later, earlier but future, or null for never.
 */
export const setResourceGrantExpiry = (
    grantId: string,
    setResourceGrantExpiryRequest: SetResourceGrantExpiryRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ResourceGrantResponse>(
      {url: `/resource-grants/${encodeURIComponent(String(grantId))}/expire`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setResourceGrantExpiryRequest, signal
    },
      options);
    }




export const getSetResourceGrantExpiryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setResourceGrantExpiry>>, TError,{grantId: string;data: SetResourceGrantExpiryRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setResourceGrantExpiry>>, TError,{grantId: string;data: SetResourceGrantExpiryRequest}, TContext> => {

const mutationKey = ['setResourceGrantExpiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setResourceGrantExpiry>>, {grantId: string;data: SetResourceGrantExpiryRequest}> = (props) => {
          const {grantId,data} = props ?? {};

          return  setResourceGrantExpiry(grantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetResourceGrantExpiryMutationResult = NonNullable<Awaited<ReturnType<typeof setResourceGrantExpiry>>>
    export type SetResourceGrantExpiryMutationBody = SetResourceGrantExpiryRequest
    export type SetResourceGrantExpiryMutationError = unknown

    /**
 * @summary Move an active grant expiry: later, earlier but future, or null for never.
 */
export const useSetResourceGrantExpiry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setResourceGrantExpiry>>, TError,{grantId: string;data: SetResourceGrantExpiryRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setResourceGrantExpiry>>,
        TError,
        {grantId: string;data: SetResourceGrantExpiryRequest},
        TContext
      > => {
      return useMutation(getSetResourceGrantExpiryMutationOptions(options));
    }
